import { render, staticRenderFns } from "./GestionPqrClientes.vue?vue&type=template&id=6c42df7c&scoped=true"
import script from "./GestionPqrClientes.vue?vue&type=script&lang=js"
export * from "./GestionPqrClientes.vue?vue&type=script&lang=js"
import style0 from "./GestionPqrClientes.vue?vue&type=style&index=0&id=6c42df7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c42df7c",
  null
  
)

export default component.exports